import { render, staticRenderFns } from "./approveL.vue?vue&type=template&id=db001478&scoped=true"
import script from "./approveL.vue?vue&type=script&lang=js"
export * from "./approveL.vue?vue&type=script&lang=js"
import style0 from "./approveL.vue?vue&type=style&index=0&id=db001478&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db001478",
  null
  
)

export default component.exports